import React, { createContext, useState, useContext } from "react";

// 1. Create the context with a default value (usually null for error checking)
const HomepageContext = createContext(null);

// 2. Create the Provider component. This is where the state lives.
export function HomepageProvider({ children }) {
  // The state is created here, with its initial value.
  const [customer, setCustomer] = useState({ id: "" });

  // The value provided to consuming components can be an object or an array.
  // An object is often clearer.
  const value = { customer, setCustomer };

  return (
    <HomepageContext.Provider value={value}>{children}</HomepageContext.Provider>
  );
}

// 3. Create the custom hook to consume the context.
export function useHomepageState() {
  const context = useContext(HomepageContext);
  if (context === null) {
    throw new Error("useHomepageState must be used within a HomepageProvider");
  }
  return context;
}